import groupings from './groupings';
import { formatDetailsFeature } from '~app/pages/Pricing/lib/packageFeatures';
import {
  Feature,
  PackageDataSet,
  FeaturesCategoryGroup,
  DetailsFeatureSets,
  DetailsFeatureValueType,
  DetailsFeatureRow,
  DetailsFeatureRowFeature,
} from '~pricing/lib/summaryPackages';
import { convertFeatureSetToMap } from '~pricing/lib/lib-helpers';
import DETAILS_COPY from '~pricing/lib/packageFeatures/details/copy';

/**
   * Returns an array with the following structure
   * [
    {
      name: 'Team Collaboration',
      features: [
        {
          feature: 'team_themes',
          title: 'Shared themes',
          packages: [
            {
              packageName: 'TEAM_ADVANTAGE_ANNUAL',
              value: true,
            },
            {
              packageName: 'TEAM_PREMIER_ANNUAL',
              value: true,
            },
            {
              packageName: 'ENT_PLATINUM',
              value: true,
            },
          ],
        },
        {
          feature: 'group_templates',
          title: 'Shared templates',
          packages: [
            {
              packageName: 'TEAM_ADVANTAGE_ANNUAL',
              value: false,
            },
            {
              packageName: 'TEAM_PREMIER_ANNUAL',
              value: true,
            },
            {
              packageName: 'ENT_PLATINUM',
              value: true,
            },
          ],
        },
      ],
    },
    {
      name: 'Survey Capabilities',
      features: [
        {
          feature: 'survey_create_limit',
          title: 'Number of surveys',
          packages: [
            {
              packageName: 'TEAM_ADVANTAGE_ANNUAL',
              value: 'UNLIMITED',
            },
            {
              packageName: 'TEAM_PREMIER_ANNUAL',
              value: 'UNLIMITED',
            },
            {
              packageName: 'ENT_PLATINUM',
              value: 'UNLIMITED',
            },
          ],
        },
      ],
    },
  ];
  */

export default function getFeatureCategories(displayedPackages: PackageDataSet): DetailsFeatureSets {
  const transformedPackages = displayedPackages.map(pkg => {
    return {
      ...pkg,
      features: convertFeatureSetToMap(pkg.features),
    };
  });

  function getFeatureValue(feature: Feature): DetailsFeatureValueType {
    if (feature?.amount) {
      return feature.amount;
    }
    if (feature?.setting) {
      return feature.setting;
    }
    return feature?.isEnabled;
  }

  return groupings.map((group: FeaturesCategoryGroup): DetailsFeatureRow => {
    return {
      name: group.category,
      features: group.features?.map((feature: string): DetailsFeatureRowFeature => {
        return {
          feature,
          ...formatDetailsFeature(feature as keyof typeof DETAILS_COPY),
          packages: transformedPackages.map(pkg => {
            return {
              packageName: pkg.package,
              value: getFeatureValue(pkg.features[feature]),
            };
          }),
        };
      }),
    };
  });
}
